import {BaseContainerModel} from '../../base-container.model';
import {bl_inv_bin_line_RowClass} from '../../../dbschema/bl_inv_bin_line.model';

export class BinLineModel extends BaseContainerModel {
  line: bl_inv_bin_line_RowClass = new bl_inv_bin_line_RowClass();
}
